import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36d95a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "href", "download"]
const _hoisted_2 = { class: "button-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))




export default /*#__PURE__*/_defineComponent({
  props: {
    class: null,
    id: null,
    href: null,
    download: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click', e: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  class?: string;
  id?: string;
  href?: string;
  download?: string;
}





const onClick = (event: Event) => {
  emit('click', event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([`button`, props.class]),
    id: props.id,
    href: props.href,
    download: props.download,
    onClick: onClick
  }, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _hoisted_3
  ], 10, _hoisted_1))
}
}

})